// extracted by mini-css-extract-plugin
export default {"editHeader":"EditHeader_editHeader__dv-iq","goBackButton":"EditHeader_goBackButton__dBiq7","angle":"EditHeader_angle__-Stbt","addButton":"EditHeader_addButton__9Jwdf"};